<template>
  <div class="column content-box webhook-log--settings">
    <!-- List webhook Logs -->
    <div>
      <div>
        <p
          v-if="!uiFlags.fetchingList && !records.length"
          class="no-items-error-message"
        >
          {{ $t('WEBHOOKS_SEND_MESSAGES_LOGS.LIST.404') }}
        </p>
        <woot-loading-state
          v-if="uiFlags.fetchingList"
          :message="$t('WEBHOOKS_SEND_MESSAGES_LOGS.LOADING')"
        />

        <table
          v-if="!uiFlags.fetchingList && records.length"
          class="woot-table width-100"
        >
          <colgroup>
            <col class="column-activity" />
            <col />
            <col />
          </colgroup>
          <thead>
            <!-- Header -->
            <th
              v-for="thHeader in $t('WEBHOOKS_SEND_MESSAGES_LOGS.LIST.TABLE_HEADER')"
              :key="thHeader"
            >
              {{ thHeader }}
            </th>
          </thead>
          <tbody>
            <tr v-for="webhookLogItem in records" :key="webhookLogItem.id">
              <td class="wrap-break-words">
                {{
                  messageTimestamp(
                    webhookLogItem.created_at,
                    'MMM dd, yyyy hh:mm a'
                  )
                }}
              </td>
              <td class="wrap-break-words">
                {{ JSON.stringify(webhookLogItem.payload) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <table-footer
      :current-page="Number(meta.currentPage)"
      :total-count="meta.totalEntries"
      :page-size="meta.perPage"
      @page-change="onPageChange"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import TableFooter from 'dashboard/components/widgets/TableFooter';
import timeMixin from 'dashboard/mixins/time';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  components: {
    TableFooter,
  },
  mixins: [alertMixin, timeMixin],
  data() {
    return {
      //
    };
  },
  computed: {
    ...mapGetters({
      records: 'webhooksSendMessagesLogs/getWebhooksSendMessagesLogs',
      uiFlags: 'webhooksSendMessagesLogs/getUIFlags',
      meta: 'webhooksSendMessagesLogs/getMeta',
    }),
  },
  mounted() {
    // Fetch API Call
    this.$store.dispatch('webhooksSendMessagesLogs/fetch', { page: 1 });
  },
  methods: {
    onPageChange(page) {
      window.history.pushState({}, null, `${this.$route.path}?page=${page}`);
      try {
        this.$store.dispatch('webhooksSendMessagesLogs/fetch', { page });
      } catch (error) {
        const errorMessage =
          error?.message || this.$t('WEBHOOKS_SEND_MESSAGES_LOGS.API.ERROR_MESSAGE');
        this.showAlert(errorMessage);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.webhook-log--settings {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 100%;
  padding-bottom: 1rem;

  .wrap-break-words {
    word-break: break-all;
    white-space: normal;
  }

  .column-activity:nth-child(1) {
    width: 15%;
  }
}
</style>
